<template>
    <section
        class="sub-container sub-container__banner"
        :class="{ 'sub-container--inactive' : !subscriptionActive && subscription}"
    >
        <div class="sub-info-container">
            <h1 class="sub-title-h1">
                {{ $lang('subscriptionInfo.my_subscription') }}
            </h1>

            <div v-if="subscription" class="sub-info-type">
                <p class="sub-info-tree" v-html="subscriptionName" />
                <p class="sub-info-price">
                    <span class="sub-info-dot">•</span>
                    <span v-if="isPromoSubscription">
                        1 ₽
                    </span>
                    <span :class="{'sub-info-price--strikethrough' : isPromoSubscription}">
                        {{ promoSubscriptionPrice }} ₽
                    </span>
                </p>
            </div>

            <div v-if="!subscription" class="sub-info-payment">
                <p class="sub-info-payment__before">
                    {{ $lang('subscriptionInfo.no_active') }}
                </p>
            </div>
            <div v-else-if="subscriptionActive" class="sub-info-payment">
                <p class="sub-info-payment__before">
                    <svg class="sub-info-icon" width="13" height="13">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-promo_active"></use>
                    </svg>
                    <span>
                        {{ $lang('subscriptionInfo.paid_to') }}
                        {{ formatDate(new Date(subscription.finished_at)) }}
                    </span>
                </p>
                <p v-if="subscription.canceled_at === null" class="sub-info-payment__next">
                    {{ $lang('subscriptionInfo.next_payment')}}
                    {{ formatDate(new Date(subscription.finished_at)) }}

                    ( {{ promoSubscriptionNextPrice }} ₽
                    <span v-if="isMonthType">
                        {{ $lang('subscriptionInfo.per_month') }}
                    </span>
                    <span v-else>
                        {{ $lang('subscriptionInfo.per_year') }}
                    </span>)
                </p>
                <p v-else class="sub-info-payment__next">
                    {{ $lang('subscriptionInfo.next_payment_canceled') }}
                </p>
                <div class="sub-info-progress">
                    <div class="sub-info-progress__bar">
                        <div class="sub-info-progress__fill" :style="{ width: progressPercentage + '%' }"></div>
                    </div>
                </div>
            </div>
            <div v-else class="sub-info-payment">
                <p class="sub-info-payment__before">
                    <svg class="sub-info-icon" width="16" height="16">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-promo_inactive"></use>
                    </svg>
                    <span>{{ $lang('subscriptionInfo.ended')}} {{ formatDate(new Date(subscription.finished_at)) }}</span>
                </p>
            </div>

            <div
                v-if="subscription"
                class="sub-buttons sub-info-buttons"
                :class="{'sub-info-buttons--inactive' : !subscriptionActive}"
            >
                <a
                    v-if="!subscriptionActive"
                    class="sub-button sub-button--primary sub-info-button"
                    href="/page/prices?isSubscriptionSelected=1"
                >
                    {{ $lang('subscriptionInfo.restore') }}
                </a>
                <button
                    class="sub-button sub-button--tertiary sub-info-button"
                    :class="{ 'sub-info-button--width' : subscriptionActive}"
                    @click="openHistory"
                >
                    {{ $lang('subscriptionHistory.title') }}
                </button>
            </div>
            <div
                v-else
                class="sub-buttons sub-info-buttons"
                :class="{'sub-info-buttons--inactive' : !subscription}"
            >
                <a
                    class="sub-button sub-button--primary sub-info-button"
                    href="#tarifs"
                >
                    {{ $lang('subscriptionInfo.choose_tariff') }}
                </a>
                <a
                    class="sub-button sub-button--secondary sub-info-button"
                    href="/page/promo"
                >
                    <svg class="sub-info-icon" width="20" height="20">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-mark"></use>
                    </svg>
                    {{ $lang('subscriptionInfo.have_promocode') }}
                </a>
            </div>
        </div>
        <div class="sub-info-image" :class="{'sub-info-image--secondary' : !subscriptionActive || !subscription}">
            <img src="../../../img/subscriptions/sub-promo.png" alt="promo">
        </div>

        <subscription-history
            :visible="showHistoryModal"
            @close="showHistoryModal = false"
        />
    </section>
</template>

<script>
import SubscriptionHistory from "./SubscriptionHistory.vue";

const types = {
    MY_TREE: 1,
    MY_TREE_PLUS: 2,
    MY_TREE_PLUS_FOR_YEAR: 3,
    MY_TREE_PLUS_PROMO: 4
};

export default {
    name: 'SubscriptionInfo',
    components: {
        SubscriptionHistory,
    },
    data() {
        return {
            subscriptionName: Vue.prototype.$lang(window.laravel.latestSubscription?.subscription_type.name + '_page'),
            showHistoryModal: false,
        }
    },
    props: {
        subscriptionActive: {
            type: Boolean,
            default: true
        },
        subscription: {
            type: Object,
        }
    },
    computed: {
        progressPercentage() {
            const now = new Date();
            const startDate = new Date(this.subscription.active_at);
            const endDate = new Date(this.subscription.finished_at);
            const total = endDate - startDate;
            const current = now - startDate;
            return Math.min(Math.max((current / total) * 100, 0), 100);
        },
        isMonthType() {
            const typeId = this.subscription.subscription_type.id;
            return typeId === types.MY_TREE || typeId === types.MY_TREE_PLUS;
        },
        promoSubscriptionPrice() {
            const subscription = this.subscription;

            if (subscription == null) {
                return 1;
            }

            if (subscription.subscription_type_id === types.MY_TREE_PLUS_PROMO &&
                subscription.price === 1) {
                return 2394;
            }

            return this.subscription.price;
        },
        promoSubscriptionNextPrice(){
            const subscription = this.subscription;

            if (subscription == null) {
                return 1;
            }

            if (subscription.subscription_type_id === types.MY_TREE_PLUS_PROMO){
                return 3990;
            }

            return subscription.price;
        },
        isPromoSubscription() {
            if (this.subscription.price > 1) {
                return false;
            }

            return this.subscription.subscription_type.is_promo;
        }
    },
    methods: {
        formatDate(date) {
            return date.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },
        openHistory() {
            this.$store.dispatch('subscription/fetchPaymentHistory')
                .then(() => {
                    this.showHistoryModal = true;
                });
        },
    },
}
</script>
